import { autoinject, computedFrom, observable } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { PageMessageService } from "../../services/page-message-service";
import { AppMessageService } from "../../services/app-message-service";
import { Insurance } from "../../models/insurance";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import 'jquery';
import 'notify';
import { Carrier } from '../../models/carrier';

@autoinject
export class UpdateTransloaderLocationDialog {
    savedAuthorityType: any;
    constructor(
        protected controller: DialogController,
        private busyService: BusyService,
        private ea: EventAggregator,
        private appMessageService: AppMessageService,
        private pageMessageService: PageMessageService,
        private api: WebApiService) {
        this.appMessageService.containerId = "update-transloader-location-dialog";
    }



    location: any = {};
    carrier: Carrier;
    nameElement: HTMLElement;
    insuranceTypes: any;
    //endorsements: Array<any> = [];
    existingInsuranceTypeIds: Array<number>;
    authorityTypeLabel: string;
    carrierDivisions = [];

    public railCarTypes = [];
    public transloaderRailCarTypes = [];

    validateFields() {
        // TODO: ensure that multiple transloader records can't be created for same division.

        if (!(this.location.locationName)) {
            alert("Location is required");
            return false;
        }
        return true;
    }

    loadTransloaderLocationById(detailsId: number): any {
        return this.api.get("Carriers", "GetTransloaderLocationById", { detailsId: detailsId})
            .then((result) => {
                let location = JSON.parse(result.response);
                this.transloaderRailCarTypes = location.railCarTypes ? location.railCarTypes.split(",") : [];
                return location;
            });
    }

    async activate(model) {

        this.appMessageService.clearPageScopedMessages();

        this.carrierDivisions = model.divisions.filter(o => model.carrierDivisions.indexOf(o.id)>-1);
        this.busyService.on();

        this.loadRailCarTypes();

        //defaults for a new contact
        if (!model.detailsId) {
            this.location = {};
            this.location.entityId = model.carrierId;
            this.location.address = {};
        } else {
            //create a copy so that the original is not modified until changes are applied
            this.location = await this.loadTransloaderLocationById(model.detailsId);
        }
        this.busyService.off();
    }

    loadRailCarTypes() {
        this.busyService.on();
        this.api.get("Carriers", "GetRailCarTypes")
            .then((result) => {
                this.railCarTypes = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }


    attached() {
        //this.nameElement.focus();
    }

    //setEndorsements(item: Insurance) {
    //item.endorsements = this.endorsements.filter(o => o.insuranceTypeId == item.insuranceTypeId);
    //}

    delete() {

        if (!confirm("Are you sure you want to delete this transloader location record?  This cannot be undone."))
            return;

        var params = {
            id: this.location.id
        };

        this.pageMessageService.clear();
        this.api.post("Carriers", "DeleteTransloaderLocation", params)
            .then(() => {
                $["notify"]("Transloader location deleted", { className: "success", position: "top center" });
                this.controller.ok();
            }, () => {
                $["notify"]("Error deleting transloader location ", { className: "error", position: "top center" });
            });
    }

    save() {
        this.pageMessageService.clear();

        if (this.validateFields()) {

            this.location.railCarTypes = this.transloaderRailCarTypes.join(",");

            this.api.post("Carriers", "UpdateTransloaderLocation", this.location)
                .then(() => {
                    if (!this.location.id) {
                        $["notify"]("Transloader location created", { className: "success", position: "top center" });
                    } else {
                        $["notify"]("Transloader location updated", { className: "success", position: "top center" });
                    }
                    this.ea.publish("carrier.transloader_location.updated", this.location.carrierId);
                    this.controller.ok();
                }, () => {
                    $["notify"]("Error saving transloader location", { className: "error", position: "top center" });
                });
        }
    }


}